// Legendary Fitment — Vehicle Filter
// vehicle-filter.js
(function () {
  'use strict';


  var VEHICLES = window.LF_VEHICLES || {};


  var elMake, elModel, elGen, elClear;


  function getCurrentTab() {
    var handle = window.LF_COLLECTION_HANDLE || '';
    var tabs = ['wheel-accessories', 'suspension', 'tires'];
    for (var i = 0; i < tabs.length; i++) {
      if (handle.endsWith('-' + tabs[i])) return tabs[i];
    }
    return '';
  }


  function getCurrentVehicle() {
    var handle = window.LF_COLLECTION_HANDLE || '';
    var tab = getCurrentTab();
    if (tab) handle = handle.slice(0, -(tab.length + 1));
    for (var make in VEHICLES) {
      for (var model in VEHICLES[make]) {
        var gens = VEHICLES[make][model];
        for (var i = 0; i < gens.length; i++) {
          if (gens[i].handle === handle) return gens[i].handle;
        }
      }
    }
    return null;
  }


  function init() {
    var root = document.getElementById('lf-vehicle-filter');
    if (!root) return;


    root.innerHTML = [
      '<div class="lf-vf">',
      '<div class="lf-vf__label">SHOP BY VEHICLE</div>',
      '<div class="lf-vf__row">',
      '<select class="lf-vf__select" id="lf-vf-make"><option value="">Make</option></select>',
      '</div>',
      '<div class="lf-vf__row">',
      '<select class="lf-vf__select" id="lf-vf-model" disabled><option value="">Model</option></select>',
      '</div>',
      '<div class="lf-vf__row">',
      '<select class="lf-vf__select" id="lf-vf-gen" disabled><option value="">Year / Gen</option></select>',
      '</div>',
      '<button class="lf-vf__clear" id="lf-vf-clear" style="display:none">&#x2715; Clear Vehicle</button>',
      '</div>'
    ].join('');


    elMake  = document.getElementById('lf-vf-make');
    elModel = document.getElementById('lf-vf-model');
    elGen   = document.getElementById('lf-vf-gen');
    elClear = document.getElementById('lf-vf-clear');


    var featured = ['Chevrolet', 'Ford', 'GMC', 'Jeep', 'RAM', 'Toyota'];
    var optgroup1 = document.createElement('optgroup');
    optgroup1.label = '— Featured Makes —';
    elMake.appendChild(optgroup1);
    featured.forEach(function(make) {
      if (!VEHICLES[make]) return;
      var opt = document.createElement('option');
      opt.value = make; opt.textContent = make;
      optgroup1.appendChild(opt);
    });
    var optgroup2 = document.createElement('optgroup');
    optgroup2.label = '— All Makes —';
    elMake.appendChild(optgroup2);
    Object.keys(VEHICLES).sort().forEach(function(make) {
      if (featured.indexOf(make) !== -1) return;
      var opt = document.createElement('option');
      opt.value = make; opt.textContent = make;
      optgroup2.appendChild(opt);
    });


    elMake.addEventListener('change', onMakeChange);
    elModel.addEventListener('change', onModelChange);
    elGen.addEventListener('change', onGenChange);
    elClear.addEventListener('click', onClear);


    var current = getCurrentVehicle();
    if (current) autoSelect(current);
  }


  function onMakeChange() {
    var make = elMake.value;
    elModel.innerHTML = '<option value="">Model</option>';
    elModel.disabled = !make;
    elGen.innerHTML = '<option value="">Year / Gen</option>';
    elGen.disabled = true;
    elClear.style.display = 'none';
    if (!make) return;
    Object.keys(VEHICLES[make]).sort().forEach(function(model) {
      var opt = document.createElement('option');
      opt.value = model; opt.textContent = model;
      elModel.appendChild(opt);
    });
  }


  function onModelChange() {
    var make = elMake.value;
    var model = elModel.value;
    elGen.innerHTML = '<option value="">Year / Gen</option>';
    elGen.disabled = !model;
    elClear.style.display = 'none';
    if (!model) return;
    VEHICLES[make][model].forEach(function(gen) {
      var opt = document.createElement('option');
      opt.value = gen.handle; opt.textContent = gen.label;
      elGen.appendChild(opt);
    });
  }


  function onGenChange() {
    var handle = elGen.value;
    if (!handle) { elClear.style.display = 'none'; return; }
    elClear.style.display = 'block';
    var tab = getCurrentTab();
    var url = '/collections/' + handle + (tab ? '-' + tab : '');
    window.location.href = url;
  }


  function onClear() {
    var tab = getCurrentTab();
    var destinations = {
      'tires': '/collections/tires',
      'suspension': '/collections/suspension',
      'wheel-accessories': '/collections/wheel-accessories',
      '': '/collections/wheels'
    };
    window.location.href = destinations[tab] || '/collections/all';
  }


  function autoSelect(vehicleHandle) {
    for (var make in VEHICLES) {
      for (var model in VEHICLES[make]) {
        var gens = VEHICLES[make][model];
        for (var i = 0; i < gens.length; i++) {
          if (gens[i].handle === vehicleHandle) {
            elMake.value = make;
            onMakeChange();
            setTimeout(function(mo, h) {
              elModel.value = mo;
              onModelChange();
              setTimeout(function() {
                elGen.value = h;
                elClear.style.display = 'block';
              }, 10);
            }.bind(null, model, vehicleHandle), 10);
            return;
          }
        }
      }
    }
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


})();
